async function getFilters() {
    try {
        const response = await fetch('/api/v1/filters');
        if (response.status !== 200) {
           throw new Error('Не удалось получить список фильтров');
        }
        return await response.json();
    } catch (e) {
        throw new Error(e);
    }
}

export default getFilters;
